import React from 'react';
import './FileInput.css';

const FileInput = ({ urlToSee = "", buttonStyle = {}, showInput = true, index = 0, accept = "application/pdf", handlerChangeFile = null, fileName = "Seleccione un archivo", icon = "fas fa-file", buttonIcon = "fas fa-search", buttonText = "Buscar" }) => {
    return (
        <div className="FileInputContainer">
            {
                showInput ?
                <div className="addon"><i className={icon}></i></div>
                : ""
            }
            
            <div className="Input">
                <input type="file" accept={accept} style={{display: "none"}} onChange={(e)=>{handlerChangeFile(e, index)}} />
                {
                    showInput ?
                    <input type="text" value={fileName} />
                    : ""
                }
            </div>
            {
                urlToSee !== "" ?
                <a href={urlToSee} target="_blank" className="SeeButton"><i className="fas fa-eye"></i></a>
                : ""
            }
            <button style={buttonStyle} onClick={(e)=>{
                e.currentTarget.parentNode.querySelector("input[type='file']").click();
            }} type="button" className="SearchButton"><i className={buttonIcon}></i> {buttonText}</button>
        </div>
    );
}
export default FileInput;